// extracted by mini-css-extract-plugin
export default {"homeContent__top":"c-i_cY","homeContent__bottom":"c-i_cZ","homeContent__cardHolder":"c-i_ea","homeContent__seoTextHolder":"c-i_eb"};